import { adminApiFetch } from './apiService';

export const permissionTemplateService = {
  fetchList: async () => {
    const response = await adminApiFetch('permission_templates', { method: 'GET' });
    return response.json();
  },

  upsert: async ({ name, permissions }) => {
    const response = await adminApiFetch('permission_templates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        permission_template: { name, permissions },
      }),
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await adminApiFetch(`permission_templates/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

export default permissionTemplateService;
